import moment from 'moment';
import Swiper, { Navigation, Pagination } from 'swiper';
import { API_KEY, HOST, DATES_INTERVAL } from "./utils/constants";
import { getFormattedTime } from "./utils/helpers";

const myHeaders = new Headers();
myHeaders.append("Authorization", `Bearer ${API_KEY}`);
myHeaders.append("Accept", "application/json");

export default {
    data() {
        return {
            loading: true,
            error: '',
            dates: [],
            selectedDate: '',
            dateFormat: 'YYYY-MM-DD',
            dateReadableFormat: 'ddd, MMM DD',
            datepickerSwiper: null,
            fixturesSwiper: null,
            fixturesData: []
        }
    },
    methods: {
        getFormattedTime,
        getDateRange(interval) {
            // const now = moment();
            const dates = [];
            let date = null;
            let label = '';

            for (let i = -interval; i <= interval; i++) {

                if (i < 0) {
                    date = moment().subtract(-1 * i, 'days')
                    label = (i === -1) ? 'Yesterday' : date.format(this.dateReadableFormat)
                } else if (i > 0) {
                    date = moment().add(i, 'days')
                    label = (i === 1) ? 'Tomorrow' : date.format(this.dateReadableFormat)
                } else {
                    date = moment()
                    label = 'Today'
                }

                dates.push({
                    value: date.format(this.dateFormat),
                    label,
                });
            }

            return dates;
        },
        getFixturesByDate(date) {
            if (!true) {
                // TODO: TEMP DEBUG
                this.error = false
                this.loading = false
                this.destroyFixturesSwiper()

                this.fixturesData = [
                    {
                        "id": 37314,
                        "name": "Hamilton A. vs Van Eijden R.",
                        "status": "canceled",
                        "duration": 9000,
                        "league_id": 3276,
                        "season_id": 19014,
                        "start_time": "2009-10-30T19:00:00\u002B00:00",
                        "league_name": "European Darts Championship",
                        "season_name": "European Championship 2009",
                        "away_team_id": 266405,
                        "home_team_id": 47506,
                        "status_reason": "Canceled",
                        "tournament_id": 66472,
                        "away_team_name": "Van Eijden R.",
                        "home_team_name": "Hamilton A.",
                        "away_team_score": 3,
                        "home_team_score": 6,
                        "tournament_name": "European Championship",
                        "league_hash_image": "dce48e5a22edb035ca876820a31dab40157d96707c1f7e3e279749780b4762a9",
                        "away_team_hash_image": "9fe8183d144425ae4ebdf6df89cc6b01bf66e08ea97d91ec63d687a52660c326",
                        "home_team_hash_image": "04b5b0bad14b84fb3bcbc674bda358360555d93e0f64e0b2164f2ec3593b1545",
                        "tournament_importance": 0
                    },
                    {
                        "id": 37315,
                        "name": "Van Gerwen M. vs Van Der Voort V.",
                        "status": "finished",
                        "duration": 9000,
                        "league_id": 3276,
                        "season_id": 19014,
                        "start_time": "2009-10-30T19:00:00\u002B00:00",
                        "league_name": "European Darts Championship",
                        "season_name": "European Championship 2009",
                        "away_team_id": 47530,
                        "home_team_id": 1810,
                        "status_reason": "Ended",
                        "tournament_id": 66472,
                        "away_team_name": "Van Der Voort V.",
                        "home_team_name": "Van Gerwen M.",
                        "away_team_score": 2,
                        "home_team_score": 6,
                        "tournament_name": "European Championship",
                        "league_hash_image": "dce48e5a22edb035ca876820a31dab40157d96707c1f7e3e279749780b4762a9",
                        "away_team_hash_image": "a6b99fb3a6361f6aa6250aa24065d94718310b1b998d3e122b85709f4df66376",
                        "home_team_hash_image": "e5281230fc54252da40c3c86448cda06e2b5d422669f501044d58d18aec97b06",
                        "tournament_importance": 0
                    },
                    {
                        "id": 37317,
                        "name": "Lewis A. vs Beaton S.",
                        "status": "upcoming",
                        "duration": 9000,
                        "league_id": 3276,
                        "season_id": 19014,
                        "start_time": "2009-10-30T19:00:00\u002B00:00",
                        "league_name": "European Darts Championship",
                        "season_name": "European Championship 2009",
                        "away_team_id": 47611,
                        "home_team_id": 47470,
                        "status_reason": "Ended",
                        "tournament_id": 66472,
                        "away_team_name": "Beaton S.",
                        "home_team_name": "Lewis A.",
                        "away_team_score": 6,
                        "home_team_score": 2,
                        "tournament_name": "European Championship",
                        "league_hash_image": "dce48e5a22edb035ca876820a31dab40157d96707c1f7e3e279749780b4762a9",
                        "away_team_hash_image": "0ffe770ea7b246ea3bc0953535cc8ef940f9091d6f4d9b76071d55ca9e73988f",
                        "home_team_hash_image": "40764b0d8431f697fe9bebf5168ca2f98a3587d2448156eb633df20ba65d14b5",
                        "tournament_importance": 0
                    },
                    {
                        "id": 37319,
                        "name": "Wade J. vs Tabern A.",
                        "status": "finished",
                        "duration": 9000,
                        "league_id": 3276,
                        "season_id": 19014,
                        "start_time": "2009-10-30T19:00:00\u002B00:00",
                        "league_name": "European Darts Championship",
                        "season_name": "European Championship 2009",
                        "away_team_id": 47597,
                        "home_team_id": 47448,
                        "status_reason": "Ended",
                        "tournament_id": 66472,
                        "away_team_name": "Tabern A.",
                        "home_team_name": "Wade J.",
                        "away_team_score": 4,
                        "tournament_name": "European Championship",
                        "league_hash_image": "dce48e5a22edb035ca876820a31dab40157d96707c1f7e3e279749780b4762a9",
                        "away_team_hash_image": "87a07593b77f25fe6a962f4d0985e610219f9785828a039dc5036a3f25bdbfa8",
                        "home_team_hash_image": "8405cdc2cc83067a1165e3cb65baed4e3b543f5dca9fd88d85a2b188b031b3d5",
                        "tournament_importance": 0
                    },
                ]

                this.initFixturesSwiper()

                return
            }

            this.error = false
            this.loading = true
            this.destroyFixturesSwiper()
            this.fixturesData = [];

            fetch(`https://${HOST}/matches-by-date?limit=4&date=eq.${date}`, {
                method: 'GET',
                headers: myHeaders,
                redirect: 'follow'
            })
                .then((response) => response.json())
                .then((data) => {

                    if (data.length) {
                        this.fixturesData = data[0].matches.slice(0, 4)
                        this.initFixturesSwiper()
                    }
                })
                .catch((err) => {
                    console.error('ERROR IN FETCH MATCHES', err);
                    console.error(err.message);
                    // this.error = 'Something went wrong while fetching details. Try again later.'
                    this.error = err.message

                })
                .finally(() => {
                    this.loading = false
                });
        },
        initDatepickerSwiper() {
            this.datepickerSwiper = new Swiper('.js-datepicker', {
                modules: [Navigation],
                spaceBetween: 10,
                centeredSlides: true,
                initialSlide: DATES_INTERVAL,
                allowTouchMove: true,
                slidesPerView: 'auto',
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            })
            this.datepickerSwiper.on('activeIndexChange', () => {
                this.selectedDate = this.dates[this.datepickerSwiper.activeIndex].value
                this.getFixturesByDate(this.selectedDate)
            });
        },
        setActiveSlide(index) { // template @click event
            this.datepickerSwiper.slideTo(index)
        },
        initFixturesSwiper() {
            let interval = setInterval(() => {
                const cards = document.querySelector('.js-fixtures-widget-cards');

                if (cards) {
                    this.fixturesSwiper = new Swiper('.js-fixtures-widget-cards', {
                        modules: [Pagination],
                        spaceBetween: 10,
                        allowTouchMove: true,
                        slidesPerView: 'auto',
                        // slidesPerView: 4,
                        pagination: {
                            el: '.swiper-pagination',
                            clickable: true,
                        },
                        breakpoints: {
                            576: {
                                spaceBetween: 20,
                            },
                        },
                    })
                    clearInterval(interval)
                    interval = null
                }
            }, 250)
        },
        destroyFixturesSwiper() {
            if (this.fixturesSwiper) {
                this.fixturesSwiper.destroy();
                this.fixturesSwiper = null
            }
        }
    },
    created() {
       const widgetEl = document.querySelector('#fixtures-widget');
       const loaderEl = document.querySelector('#fixtures-widget-loader');

       if (widgetEl) {
           widgetEl.classList.remove('hide')
       }
       if (loaderEl) {
           loaderEl.classList.add('hide')
       }

       this.dates = this.getDateRange(DATES_INTERVAL);
       this.selectedDate = moment().format(this.dateFormat);
    },
    async mounted() {
       await this.$nextTick();
       this.initDatepickerSwiper();
       await this.$nextTick();
        this.getFixturesByDate(this.selectedDate);
    }
}